export var UserRole;
(function (UserRole) {
    UserRole["PATIENT"] = "PATIENT";
    UserRole["ADMIN"] = "ADMIN";
    UserRole["SUPER_ADMIN"] = "SUPER_ADMIN";
})(UserRole || (UserRole = {}));
export var UserTier;
(function (UserTier) {
    UserTier["FREE"] = "FREE";
    UserTier["PRO"] = "PRO";
})(UserTier || (UserTier = {}));
export var AccountStatus;
(function (AccountStatus) {
    AccountStatus["PENDING"] = "PENDING";
    AccountStatus["APPROVED"] = "APPROVED";
    AccountStatus["REJECTED"] = "REJECTED";
    AccountStatus["SUSPENDED"] = "SUSPENDED";
})(AccountStatus || (AccountStatus = {}));
